import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";
import { getHello } from "../services/apiService";

function Api() {
    const dispatch = useDispatch<AppDispatch>();
    const app = useSelector((appState: IApplicationState) => appState.app);
    const [res, setRes] = useState({msg: "", type: ""});
    const count = useRef(0);
    useEffect(() => {
        count.current = 0;
    }, []);
    const sayHello = () => {
        dispatch((getHello(null) as unknown) as any).then((res: any) => {
                count.current++;
                setRes({msg: res.payload.data, type: res.type});
            });
    };
    return (
        <div className="api">
            <h3>Api test</h3>
            <button onClick={sayHello} >say hello</button>
            <br/>
            <table>
                <tbody>
                    <tr><th>#</th><th>App</th><th>Comp. msg</th><th>Comp. type</th></tr>
                    <tr>
                        <td>
                            {count.current}
                        </td>
                        <td>
                            {app.message}
                        </td>
                        <td>
                            {res.msg}
                        </td>
                        <td>
                            {res.type}
                        </td>
                    </tr>
                </tbody>    
            </table>
        </div>
    );
}

export default (Api);
